import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

const ErrorButton = styled(Button)(({ theme }) => ({
  gap: '10px',
  background: theme.palette.error.main,
  textTransform: 'none',
  fontFamily: 'Open Sans',
  fontSize: '14px',
  fontWeight: 400,
  letterSpacing: '1.25px',
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

export default ErrorButton;
